import { Row, Col } from "reactstrap";

import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { DEFAULT_LIMIT, PAGE_LIMIT_ITEMS, usePagination } from "../../hooks";
import Pagination from "../Pagination";

export interface PaginationRowProps {
  totalCount?: number;
  customLimit?: number;
}

export const PaginationRow = ({ totalCount, customLimit }: PaginationRowProps) => {
    const [searchParams] = useSearchParams();
    const { limit, onPageChanged, onUpdateLimit } = usePagination();

    useEffect(() => {
        if (customLimit && (customLimit !== limit)) {
            onUpdateLimit(customLimit);
        }
    }, [customLimit]);

    return (
        <Row className={`align-items-center py-0 mt-auto ${!totalCount ? "invisible" : ""}`}>
            <Col md="6" className="py-5">
                <Pagination
                    totalRecords={totalCount ?? 0}
                    pageLimit={customLimit ?? limit}
                    onPageChanged={onPageChanged}
                />
            </Col>

            {!customLimit && (
                <Col md="6" className="py-3 py-lg-5 text-md-end text-center col-sm">
                    <div className="btn-group-sm d-flex justify-content-end gap-1" role="group" aria-label="limit">
                        {PAGE_LIMIT_ITEMS.map((item) => (
                            <button
                                key={`page-limit-${item}`}
                                type="button"
                                className={`btn btn-outline-dark ${(Number(searchParams.get("limit") ?? DEFAULT_LIMIT) === item) ? "active" : ""}`}
                                onClick={() => onUpdateLimit(item)}
                            >
                                {item}
                            </button>
                        ))}
                    </div>
                </Col>
            )}
        </Row>
    );
};
